// extracted by mini-css-extract-plugin
export default {"container":"TenantContainer_container__g0LFw","top_button":"TenantContainer_top_button__i5maD","icon":"TenantContainer_icon__E9AGW"};